<label id="question-radio-group-label" class="fst-italic pb-2">
    {{question.label}}
</label>

<div class="d-flex pb-2 align-items-end justify-content-center stars">
    <div id="full-stars-example-two">
        <div class="rating-group">
            <input disabled checked class="rating__input rating__input--none" 
                   name="rating3" id="rating3-none" value="0" type="radio">
            
            <label aria-label="1 star" class="rating__label" for="rating3-1">
                <i class="rating__icon rating__icon--star fa fa-star"></i>
            </label>
            <input class="rating__input" name="rating3" id="rating3-1" value="1" type="radio"
                   [ngModel]="userAnswerId"
                   (ngModelChange)="changeAnswer($event)">

            <label aria-label="2 stars" class="rating__label" for="rating3-2">
                <i class="rating__icon rating__icon--star fa fa-star"></i>
            </label>
            <input class="rating__input" name="rating3" id="rating3-2" value="2" type="radio"
                   [ngModel]="userAnswerId"
                   (ngModelChange)="changeAnswer($event)">
            
            <label aria-label="3 stars" class="rating__label" for="rating3-3">
                <i class="rating__icon rating__icon--star fa fa-star"></i>
            </label>
            <input class="rating__input" name="rating3" id="rating3-3" value="3" type="radio"
                   [ngModel]="userAnswerId"
                   (ngModelChange)="changeAnswer($event)">

            <label aria-label="4 stars" class="rating__label" for="rating3-4">
                <i class="rating__icon rating__icon--star fa fa-star"></i>
            </label>
            <input class="rating__input" name="rating3" id="rating3-4" value="4" type="radio"
                   [ngModel]="userAnswerId"
                   (ngModelChange)="changeAnswer($event)">

            <label aria-label="5 stars" class="rating__label" for="rating3-5">
                <i class="rating__icon rating__icon--star fa fa-star"></i>
            </label>
            <input class="rating__input" name="rating3" id="rating3-5" value="5" type="radio"
                   [ngModel]="userAnswerId"
                    (ngModelChange)="changeAnswer($event)">
        </div>
    </div>
</div>

<!-- <div class="d-flex py-2 py-sm-4 align-items-end justify-content-center">
    <div class="px-0 px-sm-3 d-sm-flex justify-content-between align-items-center fs-6 text-secondary w-75 answer-line">
        @for (choice of possibleAnswers; track choice) {
            <label for="answer-{{choice.id}}" class="answer-option py-2 py-sm-0" [ngClass]="{'isChecked': userAnswerId === choice.id}">
                <input id="answer-{{choice.id}}" [value]='choice.id'
                       type="radio" name="answer"
                       [ngModel]="userAnswerId"
                       (ngModelChange)="changeAnswer($event)">
                <div class="custom-checkmark"></div>
                <div class="answer-text-label">{{choice.position}}</div>
            </label>
        }
    </div>
</div> -->